export default {
    SET_DATA(state, data) {
        state.data = data;
    },
};
